<ng-progress [color]="'red'" [thick]="true" [meteor]="true"></ng-progress>
<app-loader></app-loader>
<router-outlet></router-outlet>
